import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const FaceAndroidIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
}) => (
  <SvgWrapper aria-label="Face Android Icon" viewBox={viewBox} size={size}>
    <path
      fill={color}
      d="M14.13 15.498a.731.731 0 0 1 1.006 1.063 5.15 5.15 0 0 1-7.077 0l.503-.53.502-.532a3.685 3.685 0 0 0 5.066 0ZM8.03 15.527a.731.731 0 0 1 1.034-.028L8.059 16.56a.73.73 0 0 1-.03-1.034ZM12 8.044c.404 0 .732.328.732.732v3.627l-.01.191a1.94 1.94 0 0 1-1.931 1.75h-.403a.732.732 0 0 1 0-1.464h.403a.477.477 0 0 0 .468-.384l.01-.093V8.776c0-.404.327-.732.731-.732ZM7.97 8.044c.404 0 .731.328.732.732v2.015a.732.732 0 0 1-1.464 0V8.776c0-.404.328-.732.732-.732ZM16.03 8.044c.404 0 .732.328.732.732v2.015a.732.732 0 0 1-1.464 0V8.776c0-.404.328-.732.732-.732Z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M12 2a10.002 10.002 0 0 1 10 10l-.012.492a10.004 10.004 0 0 1-6.16 8.747A10.003 10.003 0 0 1 2.76 15.827a10.002 10.002 0 0 1-.749-3.335L2 12A10.002 10.002 0 0 1 12 2Zm0 1.463A8.537 8.537 0 0 0 3.463 12l.01.42A8.538 8.538 0 0 0 20.538 12l-.01-.42A8.538 8.538 0 0 0 12 3.463Z"
      clipRule="evenodd"
    />
  </SvgWrapper>
)

export default FaceAndroidIcon
